// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { scaleToGrid } from '../../../../utils/grid/gridUtils';

// Styles
import './PointerArrow.scss';

const PointerArrow = (props) => {
    const { gridSize, pointerSize } = props;

    const pointerRadius = pointerSize / 2;
    const pointerArrowGap = scaleToGrid(4, gridSize);
    const pointerWidth = scaleToGrid(10, gridSize);
    const pointerHeight = scaleToGrid(6, gridSize);

    const totalHeight = pointerRadius + pointerArrowGap + pointerHeight;

    return (
        <div className={classNames('PointerArrow')}>
            <svg
                viewBox={`0 0 ${pointerWidth} ${totalHeight}`}
                width={pointerWidth}
                height={totalHeight}
                className="arrow"
            >
                <path
                    d={`M0 ${pointerHeight} L${pointerWidth / 2} 0 L${pointerWidth} ${pointerHeight}`}
                    fill="#777777"
                    stroke="none"
                    fillRule="evenodd"
                />
            </svg>
        </div>
    );
};

PointerArrow.propTypes = {
    pointerSize: PropTypes.number,
    gridSize: PropTypes.number,
};

export default PointerArrow;
